


const Form5 = ({ state, changeHandler, loading, nextHandler, prevHandler }) => {
  const data = [
    'I wish to lose more than 10 kgs',
    ' I wish to tone my body and lose 5 to 10 kgs.',
    'I wish to lose post-pregnancy weight',
    'I have medical issues and wish to change my diet and lifestyle',
    'I wish to gain weight as Im skinny'
  ]

  const clickHandler = (text) => {
    changeHandler({
      goal: text
    });
    nextHandler();
  }

  return(
    <div className="programsContainer programsContainer5">
        <div className="fo-26 bco text-center fw-700 mfo-22">What's your Goal ?</div>

        <div className="row m-0 mt-4 activitySelection">
    {
      data.map(( elem, index ) => <Card key={elem} text={elem} full={index===data.length-1} 
        clickHandler={clickHandler} />)
    }
        </div>
    </div>
  )
}

export default Form5;

const Card = ({ full, text, clickHandler }) => {
  return(
    <div className={ full ? "col-12 col-sm-12 ms-auto me-auto mt-4 text-center" :"col-6 col-sm-6 mt-4 text-center" } onClick={() => clickHandler( text )}>
            <div className="goalsDiv">
              <div className='text-white fo-16 fw-600 cmfo-12'>{text}</div>
            </div>
          </div>
  )
}
